import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import '../../styles/core.scss';
import css from './badge.scss';

const Badge = ({ background = '', content = null }) => (
    <div>
        <div
            className={css['badge-style']}
            style={{ background: `${background}` }}
        >
            <div>{content}</div>
        </div>
    </div>
);

Badge.propTypes = {
    content: PropTypes.string,
    background: PropTypes.string
};

export default styleable(css)(Badge);



// WEBPACK FOOTER //
// ./components/badge/badge.js